import React from 'react';
import {Accordion} from 'react-bootstrap';


const App1 = () => (
    <div className="DocumentLinksPage__content-container">
        <h2>Сведения о ходе приема:</h2>
        <ul>
            <li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/prisvoenie_UIK.PDF" rel="noopener noreferrer">Порядок
                присвоения идентификационного
                кода</a></li>
            <li><a href="https://asu.art-gzhel.ru/default.aspx?WCI=ENTRANCESTATFORALL&WCE=GOTO.PAGES" target="_blank"
                   rel="noopener noreferrer">Информация о количестве поданных заявлений</a>
            </li>
            <li><a href="https://asu.art-gzhel.ru/default.aspx?WCI=ENTRANTLIST&WCE=GOTO.PAGES" target="_blank"
                   rel="noopener noreferrer">Списки лиц, подавших документы, необходимые для поступления</a>
            </li>
            <li><a href="https://asu.art-gzhel.ru/default.aspx?WCI=RECOMMENDEDLIST&WCE=GOTO.PAGES" target="_blank"
                   rel="noopener noreferrer">Ранжированные списки</a>
            </li>

            {/*<li>Сведения о зачислении</li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_906.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 29.07.2024 № 906 (Правительственная квота)</a>*/}
            {/*</li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_908.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 29.07.2024 № 908 (Особая квота. Очно)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_910.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 29.07.2024 № 910 (Особая квота. Заочно)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_912.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 29.07.2024 № 912 (Отдельная квота. Очно)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_913.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 29.07.2024 № 913 (Отдельная квота. Заочно)</a>*/}
            {/*</li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_956.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 07.08.2024 № 956 (Очно. Бюджет)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_957.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 07.08.2024 № 957 (Заочно. Бюджет)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_965.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 14.08.2024 № 965 (Очно. Бюджет)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_987.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 29.08.2024 № 987 (Очно. Бюджет)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_999.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 30.08.2024 № 999 (Очно. Внебюджет)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_1000.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 30.08.2024 № 1000 (Очно-заочно. Внебюджет)</a>*/}
            {/*</li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_1001.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 30.08.2024 № 1001 (Заочно. Внебюджет)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_1182.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 30.09.2024 № 1182 (Очно. Внебюджет)</a></li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_1183.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 30.09.2024 № 1183 (Очно-заочно. Внебюджет)</a>*/}
            {/*</li>*/}
            {/*<li><a href="https://www.art-gzhel.ru/abitur/bachelor/doc/Prikaz_priem_1184.pdf" target="_blank"*/}
            {/*       rel="noopener noreferrer">Сведения о зачислении от 30.09.2024 № 1184 (Заочно. Внебюджет)</a></li>*/}
        </ul>
    </div>
);

export default App1;
